import { RouteObject } from 'react-router-dom'
import { accountRoutes } from '@app/routes/_routes/accountRoutes'
import { bookRoutes } from '@app/routes/_routes/bookRoutes'
import { errorRoutes } from '@app/routes/_routes/errorRoutes'
import { maintenanceRoutes } from '@app/routes/_routes/maintenanceRoutes'
import { miscRoutes } from '@app/routes/_routes/miscRoutes'
import { resortRoutes } from '@app/routes/_routes/resortRoutes'

/**
 * Combined application routes
 * This file consolidates all route configurations from different feature areas
 */
export const appRoutes: RouteObject[] = [...maintenanceRoutes, ...miscRoutes, ...resortRoutes, ...accountRoutes, ...bookRoutes, ...errorRoutes]
